<div class="malfunction-filter__section">
  <div class="malfunction-filter__title">{{ "Malfunction.FilterOnType" | translate }}</div>
  <filter-bar
    filterTitle="{{ 'Malfunction.PlannedMaintenance' | translate }}"
    filterIcon="status-maintenance"
    filterType="type"
    [filterValue]="plannedWork"
    filterClassActive="active"
    [filterDefaultActive]="true"
  ></filter-bar>
  <filter-bar
    filterTitle="{{ 'Malfunction.Malfunction' | translate }}"
    filterIcon="status-malfunction"
    filterType="type"
    [filterValue]="malfunction"
    filterClassActive="active"
    [filterDefaultActive]="true"
  ></filter-bar>
</div>
